"use client";

import clsx from "clsx";
import Image from "next/image";
import { useTranslation } from "react-i18next";
import Button from "@/components/library/Button";

interface MissingDataProps {
  title?: string;
  description?: string;
  imageSrc?: string;
  imageAlt?: string;
  imageRotate?: boolean;
  imageWidth?: number;
  imageHeight?: number;
  className?: string;
  buttonText?: string;
  buttonHref?: string;
}

export default function MissingData({
  title,
  description,
  imageSrc = "/images/common/circles.webp",
  imageAlt,
  imageRotate = true,
  imageWidth = 300,
  imageHeight = 300,
  className,
  buttonText,
  buttonHref = "/",
}: MissingDataProps) {
  const { t: ct } = useTranslation("common");

  const defaultTitle = ct("missingData.title");
  const defaultDescription = ct("missingData.description");
  const defaultImageAlt = ct("missingData.imageAlt");
  const defaultButtonText = ct("notFound.goHome");

  return (
    <div
      className={clsx(
        "flex flex-col justify-center items-center p-8 text-center",
        "min-h-[400px]",
        className
      )}
    >
      <div className="space-y-6 max-w-md">
        <div className="flex justify-center mx-auto">
          <Image
            src={imageSrc}
            alt={imageAlt ?? defaultImageAlt}
            width={imageWidth}
            height={imageHeight}
            className={clsx(
              "block",
              imageRotate && "animate-spin [animation-duration:20s]"
            )}
            priority
          />
        </div>

        <div className="space-y-3">
          <h1 className="font-bold text-900 text-3xl">
            {title ?? defaultTitle}
          </h1>
          <p className="text-600 text-lg">
            {description ?? defaultDescription}
          </p>
        </div>
        <div
          className={clsx(
            "mx-auto",
            "text-center",
            "flex",
            "justify-center",
            "items-center",
            "mt-6"
          )}
        >
          <Button type="primary" href={buttonHref}>
            {buttonText ?? defaultButtonText}
          </Button>
        </div>
      </div>
    </div>
  );
}
